module.exports = __webpack_public_path__ + "img/logo.d491f5e2.png";